import type { ImportStatus } from '@servicetim/shared';
import { Badge, type BadgeProps } from '@servicetim/ui/components';
import { LoaderCircle } from 'lucide-react';

const VARIANT: Record<ImportStatus, BadgeProps['variant']> = {
  created: 'secondary',
  discovering: 'info',
  discovered: 'secondary',
  mapping: 'secondary',
  dry_run: 'info',
  ready: 'secondary',
  running: 'info',
  completed: 'success',
  failed: 'destructive',
  cancelled: 'secondary',
};

const LABEL: Record<ImportStatus, string> = {
  created: 'Created',
  discovering: 'Discovering',
  discovered: 'Discovered',
  mapping: 'Mapping',
  dry_run: 'Dry run',
  ready: 'Ready',
  running: 'Running',
  completed: 'Completed',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

const ACTIVE: ReadonlySet<ImportStatus> = new Set(['discovering', 'running']);

export function ImportStatusBadge({ status }: { status: ImportStatus }) {
  return (
    <Badge variant={VARIANT[status]} data-status={status}>
      {ACTIVE.has(status) ? <LoaderCircle className="animate-spin" /> : null}
      {LABEL[status]}
    </Badge>
  );
}
